import { UserProfile } from '@aes/core/auth/auth.models';
import { selectUserProfile } from '@aes/core/core.module';
import { AppState } from '@aes/core/core.state';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';

import { AclService } from '@aes/acl/acl.service';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';
import { FuseConfigService } from '@fuse/services/config.service';
import { AppSwitcherService } from 'app/shared/app-switcher/app-switcher.service';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'home-page',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class HomeComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _store: Store<AppState>,
    public aclService: AclService,
    private _fuseConfigService: FuseConfigService,
    private _appSwitcherService: AppSwitcherService,
    private _router: Router
  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }

  /**
   * On init
   */
  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: false
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: false
        }
      }
    };

    this._appSwitcherService
      .getModuleState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response.length === 1) {
          this._router.navigate([response[0].url]);
        }else{
          this._router.navigate(['home']);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
